import { render, staticRenderFns } from "./color-card.vue?vue&type=template&id=4e832436"
import script from "./color-card.vue?vue&type=script&lang=js"
export * from "./color-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports